import React from 'react';
import {ButtonMain} from "./buttonMain";
import {useModal} from "utils";

export const CreateCancelButtons = ({
                                        cancelText = 'Cancel',
                                        createText = 'Save',
                                        onCancel,
                                        wrapperStyles,
                                        createBtnStyles,
                                        cancelBtnStyles,
                                        classNameWrapperCreate,
                                        disabledCreateBtn,
                                        loading
                                    }) => {
    const {close} = useModal();

    return (
        <div className="modal-footer-main" style={wrapperStyles}>
            <ButtonMain
                text={cancelText}
                disabled={loading}
                cancel
                buttonMainStyles={cancelBtnStyles ? cancelBtnStyles : {
                    width: "fit-content",
                }}
                onClick={(e) => {
                    if (onCancel) {
                        onCancel(e)
                    } else {
                        close()
                    }
                }}
            />
            <ButtonMain
                classNameWrapper={classNameWrapperCreate ? classNameWrapperCreate : ''}
                text={createText}
                load={loading}
                disabled={disabledCreateBtn}
                type="submit"
                buttonMainStyles={createBtnStyles ? createBtnStyles : {
                    width: "80px",
                }}
            />
        </div>
    );
};

